/**
 * Language ISO codes
 * @module services/languages/constants
 */

/**
 * English
 */
export const LANGUAGE_EN = 'en'

/**
 * Spanish
 */
export const LANGUAGE_ES = 'es'

/**
 * German
 */
export const LANGUAGE_DE = 'de'

/**
 * French
 */
export const LANGUAGE_FR = 'fr'

export const FILE_LANGUAGE_EN = 'en_US'
export const FILE_LANGUAGE_ES = 'es_LA'
export const FILE_LANGUAGE_DE = 'de_DE'
export const FILE_LANGUAGE_FR = 'fr_FR'

export const LANGUAGE_SELECT_OPTIONS = [
  { label: 'English', value: LANGUAGE_EN },
  { label: 'French', value: LANGUAGE_FR },
  { label: 'German', value: LANGUAGE_DE },
  { label: 'Spanish', value: LANGUAGE_ES },
]
